import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Container, ModalFooter, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ModalBody from 'react-bootstrap/ModalBody';
import Button from '../../../components/Button';
import ModalHeader from '../../../components/ModalHeader';
import Tabs from '../../../components/Tabs/Tabs';
import Blockquote from '../../../components/Blockquote';
import HealthBenefitsTab from './HealthBenefitsTab'
import SpendingAccountsTab from './SpendingAccountsTab';
import LifeAndDisabilityInsuranceTab from './LifeAndDisabilityInsuranceTab';
import LifestyleBenefitsTab from './LifestyleBenefitsTab';
import useMobile from '../../../hooks/useMobileHook';

export type customBenefitModalProps = {
  showBenefitModal: boolean;
  healthBenefits: any;
  spendingAccounts: any;
  lifeAndDisabilityInsurances: any;
  lifestyleBenefits: any;
  handleCloseBenefitModal: () => void;
};

const BenefitOptionsAndCostsModal = ({
  showBenefitModal,
  healthBenefits,
  spendingAccounts,
  lifeAndDisabilityInsurances,
  lifestyleBenefits,
  handleCloseBenefitModal,
}: customBenefitModalProps) => {
  const tabsData = [
    {
      name: 'Health Benefits',
      content: <HealthBenefitsTab headerTitle={'Health Benefits'} healthBenefits={healthBenefits}/>,
    },
    {
      name: 'Spending Accounts',
      content: <SpendingAccountsTab headerTitle={'Spending Accounts'} spendingAccounts={spendingAccounts}/>,
    },
    {
      name: 'Life & Disability Insurance',
      content: <LifeAndDisabilityInsuranceTab headerTitle={'Life & Disability Insurance'} lifeAndDisabilityInsurances={lifeAndDisabilityInsurances}/>,
    },
    {
      name: 'Lifestyle Benefits',
      content: <LifestyleBenefitsTab headerTitle={'Lifestyle Benefits'} lifestyleBenefits={lifestyleBenefits}/>,
    },
  ];
  const isMobile = useMobile();
  return (
    <Modal
      fullscreen={isMobile}
      show={showBenefitModal}
      onHide={handleCloseBenefitModal}
      dialogClassName="modal-xl"
      className="custom-benefit-modal"
    >
      <ModalHeader closeButton withBorder>
        <h4 className="text-truncate">Benefit Options And Costs</h4>
      </ModalHeader>
      <ModalBody>
        <Container className="p-0">
          <Container
            className={'col-12 text-end px-0 mt-10'}
          >
            <a
              className={'text-decoration-none'}
              href={`${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`}
              target={'_blank'}
              rel="noreferrer"
            >
              <Button
                leftIcon={light('file-arrow-down')}
                variant="primary"
                className={'order-1 order-lg-3 mt-7 mt-lg-0'}
                size="sm"
              >
                Download/Print
              </Button>
            </a>
          </Container>
          <div className={'d-none d-lg-block mt-10'}>
            <Blockquote variant="primary">
              <div className={'mt-2 text-ligther-grey'}>
                <b>Important: </b>If you don’t make a different election, you’ll receive the highlighted coverage. 
              </div>
              <div className='mt-2'>
                <b>Note</b>
                <ul>
                  <li>This worksheet is for planning purposes only.</li>
                  <li>Coverage eligibility may change depending on the actual date of the event.</li>
                  <li>After you make new elections on the ‘Enroll in Benefits’ step, your cost for coverage may change.</li>
                </ul>
              </div>
            </Blockquote>
          </div>
          <Container className={'px-0 mt-10'}>
            <Tabs tabs={tabsData} />
          </Container>
        </Container>
      </ModalBody>
      <ModalFooter>
        <Button
          variant="primary-outline"
          onMouseDown={handleCloseBenefitModal}
          className="mt-7 mt-lg-0 order-1"
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default BenefitOptionsAndCostsModal;
